const trendMap = {
  up: { icon: "ri-arrow-up-line", cls: "bg-primary-500/12 text-primary-600" },
  down: { icon: "ri-arrow-down-line", cls: "bg-accent-500/12 text-accent-600" },
  flat: { icon: "ri-arrow-right-line", cls: "bg-secondary-500/15 text-secondary-700" },
  new: { icon: "ri-fire-line", cls: "bg-secondary-500/15 text-secondary-700" },
};

const features = [
  { icon: "ri-fire-line", label: "按热度智能排序" },
  { icon: "ri-time-line", label: "每日滚动更新" },
  { icon: "ri-stack-line", label: "一周瓜料全归档" },
  { icon: "ri-shield-check-line", label: "来源标注可查" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgb(63_160_118/0.10),transparent_42%),radial-gradient(circle_at_bottom_left,rgb(232_90_63/0.10),transparent_42%)]"
        aria-hidden="true"
      ></div>

      <div className="relative mx-auto max-w-7xl px-4 pt-28 pb-14 md:px-6 md:pt-36 md:pb-20">
        <div className="grid items-center gap-10 lg:grid-cols-[1.05fr_0.95fr]">
          <div className="text-left">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/10 px-3.5 py-1.5 text-xs font-medium text-primary-700">
              <i className="ri-news-line" aria-hidden="true"></i>
              本周 6 大瓜已上架，等你来吃
            </span>
            <h1 className="font-heading mt-5 text-3xl font-bold leading-tight text-foreground-950 md:text-5xl md:leading-tight">
              一周热门瓜料，
              <span className="relative whitespace-nowrap text-primary-500">
                一页看全
                <i className="ri-fire-fill absolute -top-1 -right-5 text-lg text-secondary-500" aria-hidden="true"></i>
              </span>
            </h1>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
              每日瓜料把一周热门瓜和近期新瓜集中到同一页，按热度整齐排列。不用再各个平台到处翻找，
              打开这里就能看到最新鲜、最完整的瓜田总览。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#hot"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                去看今日热榜
                <i className="ri-arrow-right-line ml-2" aria-hidden="true"></i>
              </a>
              <a
                href="#weekly"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                本周精选合集
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 sm:grid-cols-4">
              {features.map((f) => (
                <div key={f.label} className="flex flex-col gap-2">
                  <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-secondary-500/15 text-secondary-700">
                    <i className={`${f.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <dt className="text-xs leading-snug text-foreground-600">{f.label}</dt>
                </div>
              ))}
            </dl>
          </div>

          {/* 首屏主视觉卡片 */}
          <div className="relative mx-auto w-full max-w-md lg:max-w-none">
            <div className="overflow-hidden rounded-3xl border border-background-200 bg-background-50">
              <div className="relative">
                <img
                  src="https://readdy.ai/api/search-image?query=vibrant%20pop%20culture%20editorial%20collage%20of%20watermelon%2C%20theater%20stage%2C%20concert%20and%20newspaper%20clippings%2C%20warm%20coral%20and%20fresh%20green%20palette%2C%20magazine%20cover%20style%2C%20high%20detail&width=900&height=640&seq=hero-main&orientation=landscape"
                  alt="每日瓜料热门瓜主题主视觉"
                  className="aspect-[4/3] w-full object-cover object-top"
                />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-primary-600">
                  <i className="ri-fire-line" aria-hidden="true"></i> 今日 No.1
                </span>
              </div>
              <div className="flex flex-col gap-3 p-5 md:p-6">
                <p className="text-xs font-medium text-accent-600">影视 · 深度复盘</p>
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950">
                  《回声之外》结局伏笔盘点：答案其实藏在第一集
                </h3>
                <p className="text-sm leading-relaxed text-foreground-600">
                  从道具到台词逐帧比对，观众发现开放式结局早有暗示。这份复盘帮你把错过的小线索一次补齐。
                </p>
                <div className="flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line" aria-hidden="true"></i> 12.4万 次围观
                  </span>
                  <a href="#column" className="inline-flex items-center gap-1 font-medium text-primary-600 hover:text-primary-700">
                    进入专栏 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="mt-4 flex items-center justify-center gap-3 text-xs text-foreground-500">
              <i className="ri-verified-badge-line text-base text-accent-500" aria-hidden="true"></i>
              <span>已累计帮助 26 万+ 读者补完全年瓜田</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export { trendMap };